
/*
  This file is auto-generated by generate-icon-components.js. Do not edit it manually.
*/
import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

export const FhiIconCircleExclamationSelector = "fhi-icon-circle-exclamation";

/**
 * ## FhiIconCircleExclamation
 * 
 * {@link https://designsystem.fhi.no/?path=/docs/ikoner--docs}
 * 
 * @tag fhi-icon-circle-exclamation
 * @element fhi-icon-circle-exclamation
 */
@customElement(FhiIconCircleExclamationSelector)
export class FhiIconCircleExclamation extends LitElement {

  /**
   * Sets the color for the icon.
   * Should preferably be a color token. See [Color Tokens](https://designsystem.fhi.no/?path=/docs/design-tokens-farger--docs)
   * @type {string}
   */ 
  @property({ type: String }) color: string = "currentcolor";

  /**
   * Sets the size of the icon. Can be one of the predefined sizes, a number value, rem or px.
   * Number values are treated as px.
   * @type { 'xsmall' | 'small' | 'medium' | 'large' | number | string}
   */
  @property({ type: String }) size: 'xsmall' | 'small' | 'medium' | 'large' | number | `${number}px` | `${number}rem` = 'medium';

  private get _size(): string {
    switch (this.size) {
      case 'xsmall': 
        return '1rem'; 
      case 'small':
        return '1.25rem';
      case 'medium':
        return '1.5rem'; 
      case 'large':
        return '2rem'; 
      default:
        if (String(this.size).endsWith('px') || String(this.size).endsWith('rem')) {
          return String(this.size);
        }
        if (isNaN(Number(this.size))) {
          console.warn(`Invalid size value: ${this.size}. Falling back to default size '1.5rem'.`)
          return '1.5rem';
        }
        return `${this.size}px`;
    }
  }

  render() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${this._size}" height="${this._size}" fill="${this.color}"><path fill-rule="evenodd" d="M21.25 12a9.25 9.25 0 1 0-18.5 0 9.25 9.25 0 0 0 18.5 0m1.5 0c0 5.937-4.813 10.75-10.75 10.75S1.25 17.937 1.25 12 6.063 1.25 12 1.25 22.75 6.063 22.75 12m-10.74 3 .102.005a1 1 0 0 1 0 1.99L12.01 17H12a1 1 0 1 1 0-2zm-.76-7v4a.75.75 0 0 0 1.5 0V8a.75.75 0 0 0-1.5 0" clip-rule="evenodd"/></svg>
    `;
  }
      
  static styles = css`
    :host {
      display: flex;
      max-height: min-content;
      max-width: min-content;
    }
  `;
  }
